<template>
  <div class="artistas">
    <!-- Event Slide -->
    <TheSlider></TheSlider>
    <!-- Event Counter -->
    <v-card
      class="text-center"
      dark
    >
      <v-card-text
        class="d-flex align-center justify-center flex-row"
      >
        <VueCountdownTimer
          @start_callback="startCallBack('event started')"
          @end_callback="endCallBack('event ended')"
          :start-time="getHoursStart"
          :end-time="getHoursEnd"
          :interval="1000"
          :start-label="'Evento em'"
          :end-label="'Encerra em'"
          label-position="begin"
          :end-text="'Evento finalizado!'"
          :day-txt="'dias'"
          :hour-txt="':'"
          :minutes-txt="':'"
          :seconds-txt="''"
          class="d-flex align-center justify-center flex-row"
        >
          <template slot="countdown" slot-scope="scope">
            <div class="d-flex flex-row">
              <v-card
                outlined
                class="mx-1 ml-6 text-center"
              >
                <v-card-title class="text-h3">
                  {{scope.props.days}}
                </v-card-title>
                <v-card-subtitle>
                  {{scope.props.dayTxt}}
                </v-card-subtitle>
              </v-card>
              <v-card
                outlined
                class="mx-1 text-center"
              >
                <v-card-title class="text-h3">
                  {{scope.props.hours}}
                </v-card-title>
                <v-card-subtitle>
                  hor
                </v-card-subtitle>
              </v-card>
              <v-card
                outlined
                class="mx-1 text-center"
              >
                <v-card-title class="text-h3">
                  {{scope.props.minutes}}
                </v-card-title>
                <v-card-subtitle>
                  min
                </v-card-subtitle>
              </v-card>
              <v-card
                outlined
                class="mx-1 text-center"
              >
                <v-card-title class="text-h3">
                  {{scope.props.seconds}}
                </v-card-title>
                <v-card-subtitle>
                  seg
                </v-card-subtitle>
              </v-card>
            </div>
          </template>
        </VueCountdownTimer>
      </v-card-text>
    </v-card>
    <!-- Titulo Box -->
    <v-container
      class="grey lighten-5 mt-6 mb-6"
      fluid
    >
      <v-row
        class="align-center"
      >
        <v-col
          class="fill-height"
        >
          <div class="text-h3 mb-4">
            Evento Nome
          </div>
          <div class="text-justify mb-10">
            Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
            sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
            Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet.
          </div>
        </v-col>
        <v-col
          class="fill-height"
        >
          <v-card
            class="mx-auto fill-height"
            outlined
          >
            <v-img
              src="https://via.placeholder.com/686x400"
            ></v-img>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        no-gutters
      >
        <v-col>
          <div class="fill-height pa-2">
            <v-row>
              <v-col
                class="col-3"
                v-for="index in 4"
                :key="index"
              >
                <v-card
                  class="mx-auto fill-height"
                  outlined
                >
                  <v-img
                    src="https://via.placeholder.com/400x500"
                  ></v-img>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-title class="headline mb-1">
                        Foto Evento {{ index }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
                        sed quia consequuntur magni dolores eos qui ratione voluptatem sequi
                        nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet.
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import TheSlider from '@/views/home/components/TheSlider';
import RegisterMixin from '@/mixins/RegisterMixin';
import moment from 'moment';

export default {
  name: 'Artistas',
  components: {
    TheSlider,
  },
  mixins: [RegisterMixin],
  data() {
    return {
      day: Math.ceil(Math.random() * 10),
    };
  },
  computed: {
    getHoursStart() {
      return moment().add(this.day, 'day');
    },
    getHoursEnd() {
      return moment().add(this.day + 1, 'day');
    },
  },
  created() {
    // UserService.retriverProfileInfo();
    this.$bus.on(this.$events.GET_PARTNER, () => {
      // UserService.retriverProfileInfo();
    });
  },
  methods: {
    startCallBack() {
    },
    endCallBack() {
    },
  },
};
</script>
<style lang='scss'>
@import '@/static/css/Variables.scss';
</style>
